<div *ngIf="gitlabInstanceName" class="container-fluid">
  <div class="row">
    <div class="col-3">
      <app-dashboard-runners [gitlabInstanceName]="gitlabInstanceName" [runners]="runners"></app-dashboard-runners>
    </div>

    <div class="col-9">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <app-dashboard-active-pipelines
              (trackItemEvent)="trackedBranches.loadPipelines()"
              [gitlabInstanceName]="gitlabInstanceName"
              [pipelines]="runningPipelines">
            </app-dashboard-active-pipelines>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <app-dashboard-tracked-branches
              #trackedBranches
              [gitlabInstanceName]="gitlabInstanceName">
            </app-dashboard-tracked-branches>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <app-dashboard-merge-requests
              [gitlabInstanceName]="gitlabInstanceName">
            </app-dashboard-merge-requests>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
